<template>
  <div class="py-3">
    <div class="bg-white">
      <div class="pt-3 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Seguimiento de Solicitud
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Número de Solicitud:
              </p>
              <p class="font-16">
                {{ order.requestNumber | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Fecha de Solicitud:
              </p>
              <p class="font-16">
                {{ order.requestDate | date }}
              </p>
            </div>
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Sometido Por:
              </p>
              <p class="font-16">
                {{ order.submittedBy | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Razón:
              </p>
              <p class="font-16">
                {{ order.reason | empty }}
              </p>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Comentario:
              </p>
              <p class="font-16">
                {{ order.comment | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-3 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información del Material/Equipo
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Nombre de Material/Equipo:
              </p>
              <p class="font-16">
                {{ order.title | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Categoría:
              </p>
              <p class="font-16">
                {{ order.category | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Tipo Salón:
              </p>
              <p class="font-16">
                {{ order.saloon | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-3 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información de Localidad
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Centro:
              </p>
              <p class="font-16">
                {{ order.center | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Municipio:
              </p>
              <p class="font-16">
                {{ order.municipality | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3">
              <p class="font-14 text-muted mb-1">
                Escuela:
              </p>
              <p class="font-16">
                {{ order.school | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomBalloon from 'custom-balloon';

export default {
  name: 'RequestInfo',
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomBalloon,
  },
};
</script>

<style lang="scss" scoped>
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
</style>
